import { useState, useEffect } from 'react';
import { CustomCursor } from './components/CustomCursor';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Trust } from './components/Trust';
import { Services } from './components/Services';
import { Process } from './components/Process';
import { CaseStudies } from './components/Cases';
import { Testimonials } from './components/Testimonials';
import { Credentials } from './components/Credentials';
import { Share } from './components/Share';
import { CTA, Footer } from './components/CTAFooter';
import { useRevealObserver } from './hooks/useRevealObserver';
import { useParallax } from './hooks/useParallax';
import { useProcessScrollAnimation } from './hooks/useProcessScrollAnimation';
import './styles.css';
import './styles/hero.css';
import './styles/services.css';
import './styles/sections.css';
import './styles/cases-stack.css';
import './styles/cta-pro.css';
import './styles/academy.css';
import './styles/credentials.css';
import './styles/share.css';

const TWEAK_DEFAULTS = {
  "motion": "standard",
  "cursor": true
};

function App() {
  const [tweaks] = useState(TWEAK_DEFAULTS);

  // Motion intensity → multiplier
  const motionMultiplier = tweaks.motion === "off" ? 0 : tweaks.motion === "low" ? 0.4 : tweaks.motion === "high" ? 1.6 : 1;

  useEffect(() => {
    document.body.classList.toggle("motion-low", tweaks.motion === "off");
  }, [tweaks.motion]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useRevealObserver();
  useParallax(motionMultiplier);
  useProcessScrollAnimation();

  return (
    <>
      <CustomCursor enabled={tweaks.cursor && tweaks.motion !== "off"} />
      <Nav />
      <Hero />
      <Trust />
      <Services />
      <Process />
      <CaseStudies />
      <Testimonials />
      <Credentials />
      <Share />
      <CTA />
      <Footer />
    </>
  );
}

export default App;
